<div class="container-fluid accordion-container accordion-inner"
  [ngClass]="{'accordion-error': question?.validationError}" id="accordion_question_{{question?.id}}">
  <mat-accordion class="accordion" multi>
    <mat-expansion-panel [expanded]="accordionOpened">
      <mat-expansion-panel-header class="py-2">
        <mat-panel-title>
          <span>
            {{ question.question }}
            @if (question.required) {
              *
            }
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (isResponse) {
        @if (question?.description) {
          <h4 class="font-weight-bold col-12 w-100 pl-0 mt-3">{{ "generic.description" | translate }}</h4>
          <p class="formatted">{{ question?.description }}</p>
        }
        <!--            <h4 class="font-weight-bold col-12 w-100 pl-0 {{ question?.description ? 'mt-4' : 'mt-3'}}">-->
        <!--              <ng-container *ngIf="surveyService.isOpenedQuestion(question.typology); else elseBlock">{{ "generic.your-answer" | translate }}</ng-container>-->
        <!--              <ng-template #elseBlock>{{ "generic.fe" | translate }}</ng-template>-->
      <!--            </h4>-->
      @if (isOpenedQuestion) {
        <h4 class="font-weight-bold col-12 w-100 pl-0 mt-3 d-flex align-items-center section-title-purple">
          <fa-icon [icon]="faCommentDots" class="section-icon mr-2"></fa-icon>
          {{ "generic.your-answer" | translate }}
        </h4>
        @if (!isConsensusQuestion) {
          <mat-form-field class="w-100 mt-2" appearance="fill">
            <mat-label>
              {{
              "generic.your-answer" | translate
              }}
            </mat-label>
            <ng-container>
              <textarea [required]="question.required" class="description" matInput
                name="criterio_description{{question.id}}_response" [(ngModel)]="question.response.answer" [ngModelOptions]="{standalone: true}"
                [disabled]="survey.answered">
              </textarea>
            </ng-container>
          </mat-form-field>
          @if (!survey.answered && survey?.customs?.speech_to_text_enabled) {
            <div class="answer-speech-recorder-row">
              <app-speech-to-text-recorder
                [surveyId]="survey?.id"
                [questionId]="question?.id"
                [disabled]="survey.answered"
                [language]="currentTranscriptionLanguage"
                targetField="answer"
                [maxDurationSeconds]="300"
                [isMedical]="!!survey?.customs?.medical_speech_to_text_enabled"
                (audioAttachmentCreated)="onSpeechToTextAudioAttachmentCreated($event)"
                (transcriptionCompleted)="onSpeechToTextCompleted($event)">
              </app-speech-to-text-recorder>
            </div>
          }
        }
      }
      @if (isQuantitativeQuestion) {
        <div class="mt-5">
          <h4 class="font-weight-bold col-12 w-100 pl-0 mt-0 mb-2 d-flex align-items-center section-title-purple">
            <mat-icon class="section-icon mr-2">straighten</mat-icon>
            {{ "components.decision-table.new-decision-table.compile-proposal.measure-unit" | translate | titlecase }}: {{ getCustoms.measure_unit }}
          </h4>
        </div>
        @if (!getCustoms?.use_slider) {
          <div class="mt-2">
            <h4 class="font-weight-bold col-12 w-100 pl-0 mt-0 mb-2 d-flex align-items-center section-title-purple">
              <mat-icon class="section-icon mr-2">linear_scale</mat-icon>
              {{ "generic.range-value" | translate | titlecase }}: {{ getCustoms.min }} - {{ getCustoms.max }}
            </h4>
          </div>
        }
        @if (getCustoms.use_slider) {
          <div class="container row pt-0 pb-4 my-3">
            <div class="slider-preview-wrapper w-100 mt-4" [class.tricolor]="getCustoms?.tricolor">
              <mat-slider name="criterio_quantitative_{{question.id}}_response_slider"
                class="w-100 cdk-focused" [discrete]="true" [min]="getCustoms.min" [max]="getCustoms.max" [step]="getCustoms.step"
                [disabled]="survey.answered" color="primary">
                <input matSliderThumb name="criterio_quantitative_{{question.id}}_response" [max]="getCustoms.max"
                  [min]="getCustoms.min" [step]="getCustoms.step" [(ngModel)]="question.response.answer" [ngModelOptions]="{standalone: true}">
              </mat-slider>
            </div>
            <div class="d-flex justify-content-between w-100 mb-2 px-2">
              @if (!getCustoms.use_custom_min_max_labels) {
                <small class="float-left">{{ 'components.responses.absolutely-not-sure' | translate }}</small>
                <small class="float-right">{{ 'components.responses.absolutely-sure' | translate }}</small>
              } @else {
                <small class="float-left">{{ getCustoms.min_label }}</small>
                <small class="float-right">{{ getCustoms.max_label }}</small>
              }
            </div>
          </div>
        }
        @if (!getCustoms.use_slider) {
          <br>
            <mat-form-field appearance="fill" class="mt-4">
              <input type="number" class="form-control" matInput name="value" step="1" [max]="getCustoms.max"
                [min]="getCustoms.min" [disabled]="survey.answered" [(ngModel)]="question.response.answer" [ngModelOptions]="{standalone: true}"
                [placeholder]="'generic.your-answer' | translate">
            </mat-form-field>
          }
        }
        @if (isConsensusQuestion) {
          <div class="col-12 mt-5">
            <div class="d-flex ml-2 my-2 toogle-button-container consensus-toggle-container justify-content-center">
              <mat-button-toggle-group [disabled]="survey.answered" name="fontStyle" aria-label="Font Style"
                [(ngModel)]="question.response.answer" [ngModelOptions]="{standalone: true}" [hideMultipleSelectionIndicator]="true"
                [hideSingleSelectionIndicator]="true" class="consensus-toggle-group">
                <mat-button-toggle value="AGREE" class="green">
                  <mat-icon class="consensus-icon">thumb_up</mat-icon>
                  {{ 'components.responses.consensus.agree' | translate }}
                </mat-button-toggle>
                @if (!question.required) {
                  <mat-button-toggle value="ABSTAINED" class="yellow">
                    {{ 'components.responses.consensus.abstained' | translate }}
                  </mat-button-toggle>
                }
                <mat-button-toggle value="DISAGREE" class="red">
                  <mat-icon class="consensus-icon">thumb_down</mat-icon>
                  {{ 'components.responses.consensus.disagree' | translate }}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <div class="col-12 mt-5">
            <h4 class="font-weight-bold col-12 w-100 pl-0 mt-0 mb-2 d-flex align-items-center section-title-purple">
              <mat-icon class="section-icon mr-2">rate_review</mat-icon>
              {{ 'generic.feedback' | translate }}
              @if (getCustoms?.feedback_is_mandatory) {
                <span class="ml-1">({{ 'generic.required' | translate }})</span>
              } @if (!getCustoms?.feedback_is_mandatory) {
                <span class="ml-1">({{ "generic.optional" | translate }})</span>
              }
            </h4>
            <mat-form-field class="full-width mt-2" appearance="fill">
              <mat-label>{{ "generic.your-answer" | translate }}</mat-label>
              <textarea class="description my-2" matInput [required]="getCustoms?.feedback_is_mandatory" rows="3"
              [(ngModel)]="question.response.feedback" [ngModelOptions]="{standalone: true}"></textarea>
            </mat-form-field>
          </div>
          @if (getCustoms.use_slider) {
            <div class="container row pt-0 pb-4 my-3">
              <small class="col-12">{{ 'components.responses.ask-confidence' | translate }}</small>
              <div class="slider-preview-wrapper w-100 mt-4" [class.tricolor]="getCustoms?.tricolor">
                <mat-slider name="criterio_consensus_{{question.id}}_response_slider"
                  class="w-100 cdk-focused" [disabled]="survey.answered"
                  color="primary" [discrete]="true" [min]="getCustoms.min" [max]="getCustoms.max" [step]="getCustoms.step">
                  <input matSliderThumb name="criterio_consensus_{{question.id}}_confidence" [max]="getCustoms.max"
                    [min]="getCustoms.min" [step]="getCustoms.step" [(ngModel)]="question.response.customs.confidence" [ngModelOptions]="{standalone: true}">
                </mat-slider>
              </div>
              <div class="d-flex justify-content-between w-100 mb-2 px-2">
                @if (!getCustoms.use_custom_min_max_labels) {
                  <small class="float-left">{{ 'components.responses.absolutely-not-sure' | translate }}</small>
                  <small class="float-right">{{ 'components.responses.absolutely-sure' | translate }}</small>
                } @else {
                  <small class="float-left">{{ getCustoms.min_label }}</small>
                  <small class="float-right">{{ getCustoms.max_label }}</small>
                }
              </div>
            </div>
          }
        }
        @if (isGridQuestion) {
          <div class="w-100 mb-5">
            @if (isResponse) {
              <h4 class="font-weight-bold col-12 w-100 pl-0 mt-4 mb-2 d-flex align-items-center section-title-purple">
                <mat-icon class="section-icon mr-2">grid_on</mat-icon>
                {{ "generic.rows" | translate | titlecase }} / {{ "generic.columns" | translate | titlecase }}
              </h4>
            }
            <app-grid-question-table class="w-100" [(rows)]="question.grid_rows" [(columns)]="question.grid_columns"
            [isResponse]="isResponse"></app-grid-question-table>
          </div>
        }
        @if (isMultipleChoiceQuestion || isCheckboxQuestion) {
          <ng-container class="mt-2 mb-3 row">
            @if (isCheckboxQuestion || (isMultipleChoiceQuestion && !getCustoms.use_cascade_select)) {
              <h4 class="font-weight-bold col-12 w-100 pl-0 mt-4 mb-2 d-flex align-items-center section-title-purple">
                <mat-icon class="section-icon mr-2">format_list_bulleted</mat-icon>
                {{ "generic.options" | translate }}
              </h4>
            }
            <div class="col-12 row">
              @if (isMultipleChoiceQuestion) {
                @if (getCustoms?.use_cascade_select) {
                  <h4 class="font-weight-bold col-12 w-100 pl-0 mt-2 mb-2 d-flex align-items-center section-title-purple">
                    <mat-icon class="section-icon mr-2">format_list_bulleted</mat-icon>
                    {{ "generic.options" | translate }}
                  </h4>
                  <mat-form-field appearance="fill" class="mt-2">
                    <mat-label>Seleziona un'opzione</mat-label>
                    <mat-select name="question_choice_{{question.id}}" [(ngModel)]="question.response.choice" [ngModelOptions]="{standalone: true}"
                      [disabled]="survey.answered">
                      @for (choice of question.choices; track choice) {
                        <mat-option [value]="choice.id">
                          {{ choice.title }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                } @else {
                  <mat-radio-group name="question_choice_radio_{{question.id}}" [disabled]="survey.answered"
                    class="col-12" [(ngModel)]="question.response.choice" [ngModelOptions]="{standalone: true}">
                    @for (choice of question.choices; track choice; let optionIndex = $index) {
                      <div class="row">
                        <div class="col-12">
                          <mat-radio-button [value]="choice.id">{{ choice.title }}</mat-radio-button>
                          @if (question.response.choice === choice.id && choice?.customs?.has_open_response) {
                            <mat-form-field
                              appearance="fill" class="w-100 mt-4">
                              <mat-label>{{ "generic.your-answer" | translate }}</mat-label>
                              <input matInput name="question_open_response_{{question.id}}_{{choice?.id}}"
                                [disabled]="survey.answered" [(ngModel)]="question.response.customs.open_response_value" [ngModelOptions]="{standalone: true}">
                            </mat-form-field>
                          }
                        </div>
                      </div>
                    }
                  </mat-radio-group>
                }
              }
              @if (isCheckboxQuestion) {
                <div class="col-12">
                  @for (choice of question.choices; track choice; let optionIndex = $index) {
                    <div class="row">
                      <div class="col-12">
                        <mat-checkbox name="choice_checked_{{question.id}}_{{choice?.id}}" [disabled]="survey.answered"
                          [(ngModel)]="choice.checked" [ngModelOptions]="{standalone: true}">{{ choice.title }}
                        </mat-checkbox>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </ng-container>
        }
        @if (!isConsensusQuestion) {
          <h4 class="font-weight-bold col-12 w-100 pl-0 {{isMultipleChoiceQuestion ? 'mt-5' : 'mt-2'}} mb-2 d-flex align-items-center section-title-purple">
            <mat-icon class="section-icon mr-2">rate_review</mat-icon>
            {{ "pages.surveys.responses.comment-your-answer" | translate }}
            (@if (getCustoms.feedback_is_mandatory) {
              <span class="ml-1">{{ 'generic.required' | translate }}</span>
            } @if (!getCustoms.feedback_is_mandatory) {
              <span class="ml-1">{{ "generic.optional" | translate }}</span>
            })
          </h4>
          <mat-form-field class="w-100 mt-2" appearance="fill">
            <mat-label>{{ "generic.your-answer" | translate }}</mat-label>
            <ng-container>
              <textarea class="description" matInput name="criterio_description{{question.id}}_response"
                [(ngModel)]="question.response.feedback" [ngModelOptions]="{standalone: true}" [required]="getCustoms?.feedback_is_mandatory"
                [disabled]="survey.answered">
              </textarea>
            </ng-container>
          </mat-form-field>
        }
        <div class="my-3 row">
          @if (isResponse) {
            <div class="col-12">
              <app-attachments-list [attachments]="question.response.attachments" [editable]="!survey.answered" [buttonToAdd]="survey?.attachments_enabled"></app-attachments-list>
            </div>
          }
        </div>
        <div class="question-actions-buttons">
          <div class="question-actions-row">
            <div class="question-actions-left">
              @if (question?.attachments?.length > 0) {
                <button mat-stroked-button class="documentation-attached-btn" (click)="showAttachments()">
                  <fa-icon [icon]="faFolderOpen" class="documentation-icon"></fa-icon>
                  {{ "generic.documentation-attached" | translate }}
                </button>
              }
            </div>
            <div class="question-actions-right">
              <!-- No more 'Add' button here as it's now inside app-attachments-list -->
            </div>
          </div>
        </div>
      }
      @if (!isResponse) {
        <!-- Top Row: Name, Section, Type -->
        <div class="row justify-content-between">
          <div class="col-6">
            <mat-form-field appearance="fill" class="w-100 pb-0">
              <mat-label>{{ "generic.title" | translate }} </mat-label>
              <input required [disabled]="!editable" [(ngModel)]="question.question" [ngModelOptions]="{standalone: true}" matInput
                name="criterio_title_{{question.id}}">
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field appearance="fill" class="w-100 pb-0">
              <mat-label>{{ "generic.section" | translate }}</mat-label>
              <input [disabled]="!editable" [(ngModel)]="getCustoms.section" [ngModelOptions]="{standalone: true}" matInput
                name="criterio_section_{{question.id}}">
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100 pb-0" appearance="fill">
              <mat-label>{{ "generic.type" | translate }} </mat-label>
              <mat-select name="question_typology_{{question.id}}" [disabled]="!editable" required
                [(ngModel)]="question.typology" [ngModelOptions]="{standalone: true}" (selectionChange)="onTypologyChange()"
                name="criterio_typology_{{question.id}}">
                @for (typology of surveyService.questionTypologies; track typology) {
                  <mat-option [disabled]="!editable"
                    [value]="typology.id">{{ typology.title | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        @if (getCustoms?.use_description) {
          <mat-form-field class="w-100 mb-4" appearance="fill">
            <mat-label>{{ "generic.description" | translate }}</mat-label>
            <textarea [disabled]="!editable" class="description" matInput rows="4"
              name="criterio_description{{question.id}}"
              placeholder="{{ 'components.proposals.new-proposal.placeholders.insert-description' | translate }}"
              [(ngModel)]="question.description" [ngModelOptions]="{standalone: true}">
            </textarea>
          </mat-form-field>
        }
        <!-- Quantitative Settings -->
        @if (isQuantitativeQuestion) {
          <div class="w-100">
            <app-question-quantitative [question]="question" [editable]="editable"
            [isResponse]="isResponse"></app-question-quantitative>
          </div>
        }
        <!-- Consensus Question -->
        @if (isConsensusQuestion) {
          <div class="w-100">
            <app-question-consensus [question]="question" [editable]="editable"
            [isResponse]="isResponse"></app-question-consensus>
          </div>
        }
        @if (isMultipleChoiceQuestion || isCheckboxQuestion) {
          <div class="mt-0 mb-3 w-100">
            <app-question-options [question]="question" [editable]="editable"></app-question-options>
          </div>
        }
        @if (isGridQuestion) {
          <div class="w-100">
            <app-grid-question-table class="w-100" [editable]="editable" [(rows)]="question.grid_rows"
            [(columns)]="question.grid_columns" [isResponse]="isResponse"></app-grid-question-table>
          </div>
        }
        @if (!(canManageAttachments === false && question?.attachments?.length === 0)) {
          <div class="question-actions-buttons">
            <div class="question-actions-row">
              <div class="question-actions-left">
                @if (question?.attachments.length > 0) {
                  <button mat-stroked-button class="documentation-attached-btn" (click)="showAttachments()">
                    <fa-icon [icon]="faFolderOpen" class="documentation-icon"></fa-icon>
                    {{ "generic.documentation-attached" | translate }}
                  </button>
                }
              </div>
              <div class="question-actions-right">
                @if (canManageAttachments) {
                  <button mat-icon-button class="allega-evidenze-btn" aria-label="add attachment"
                    [matMenuTriggerFor]="menuAttachment">
                    <mat-icon>attach_file</mat-icon>
                  </button>
                  <mat-menu #menuAttachment="matMenu">
                    <button mat-menu-item (click)="onClickAddNewEvidence('PUBMED')">
                      <mat-icon aria-hidden="false" class="attachment-evidence-icon">science</mat-icon>
                      Pubmed
                    </button>
                    <button mat-menu-item (click)="onClickAddNewEvidence('FILE')">
                      <mat-icon aria-hidden="false" class="attachment-evidence-icon">insert_drive_file</mat-icon>
                      File
                    </button>
                    <button mat-menu-item (click)="onClickAddNewEvidence('LINK')">
                      <mat-icon aria-hidden="false" class="attachment-evidence-icon">link</mat-icon>
                      Link
                    </button>
                  </mat-menu>
                  @if (clonable) {
                    <button mat-icon-button class="allega-evidenze-btn" aria-label="duplicate"
                      (click)="duplicateQuestion()">
                      <mat-icon>file_copy</mat-icon>
                    </button>
                  }
                  @if (isDeletable) {
                    <button (click)="removeQuestion()" mat-icon-button class="allega-evidenze-btn" aria-label="delete">
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                  <button mat-icon-button class="allega-evidenze-btn" aria-label="settings"
                    [matMenuTriggerFor]="menuSettings">
                    <mat-icon>settings</mat-icon>
                  </button>
                  <mat-menu #menuSettings="matMenu">
                    @for (option of surveyService.selectOptions; track option) {
                      @if (option.enabledTypologies.includes(question.typology)) {
                        <div mat-menu-item (click)="settingsItemSelected($event)">
                          <mat-checkbox name="custom_option_{{question.id}}_{{option.key}}"
                            [(ngModel)]="getCustoms[option.key]" [ngModelOptions]="{standalone: true}">{{ option.label | translate }}</mat-checkbox>
                        </div>
                      }
                    }
                  </mat-menu>
                  <div class="question-actions-toggle">
                    <mat-button-toggle-group [(ngModel)]="question.required" [ngModelOptions]="{standalone: true}" name="question_{{question.id}}_required"
                      [hideMultipleSelectionIndicator]="true" [hideSingleSelectionIndicator]="true">
                      <mat-button-toggle [value]="true">{{ "generic.required" | translate }}</mat-button-toggle>
                      <mat-button-toggle [value]="false">{{ "generic.optional" | translate }}</mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      }
    </mat-expansion-panel>
  </mat-accordion>
</div>
